import { FunctionComponent } from "react";
import { errorNotice, HtmlNotice } from "@pjs/core-ui";
import { IAccountSettingsErrorProps } from "./interfaces/IAccountSettingsErrorProps";

export const AccountSettingsError: FunctionComponent<IAccountSettingsErrorProps> = (props) => {
    const message = `<strong>${props.title}</strong> ${props.content}`;
    return <HtmlNotice content={message} ariaLabel={props.content} type={errorNotice} />;
};
